import { useEffect, useState } from "react";
import {
  Modal,
  Paper,
  Grid,
  Button,
  Typography,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";

import { MassiveAdditionalItem } from "types";
import CustomNumberInput from "components/CustomNumberInput";

type Props = {
  open: boolean;
  handleOpen: () => void;
  value: MassiveAdditionalItem;
  onEdit: (massiveAdditionalItem: MassiveAdditionalItem) => void;
};

export default function EditMassiveAdditionalItemModal({
  open = true,
  handleOpen,
  value,
  onEdit,
}: Props) {
  const [data, setData] = useState<MassiveAdditionalItem>(value);

  useEffect(() => {
    if (open) {
      setData(value);
    }
  }, [open, value]);

  const handleChange = <K extends keyof Omit<MassiveAdditionalItem, "id">>(
    name: K,
    value: Omit<MassiveAdditionalItem, "id">[K],
  ) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleNumberChange = <
    K extends keyof Omit<MassiveAdditionalItem, "id">,
  >(
    name: K,
    rawValue: string,
  ) => {
    setData((prev) => ({
      ...prev,
      [name]: rawValue,
    }));
  };

  const onSubmit = (updatedAdditionalItem: MassiveAdditionalItem) => {
    onEdit({
      ...updatedAdditionalItem,
    });
    handleOpen();
  };

  return (
    <Modal open={open} onClose={handleOpen}>
      <Paper
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { sm: "90%", md: "30rem" },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Grid container spacing={2}>
          <Typography variant="h5" gutterBottom>
            Editar precio de ítems adicionales
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth margin="none">
              <InputLabel id="type-label">Tipo</InputLabel>
              <Select
                labelId="type-label"
                label={"Tipo"}
                value={data.type}
                onChange={(e) => handleChange("type", e.target.value)}
              >
                <MenuItem key={"$"} value={"$"}>
                  Precio
                </MenuItem>
                <MenuItem key={"%"} value={"%"}>
                  Porcentaje
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <CustomNumberInput
              label={data.type === "%" ? "Porcentaje" : "Precio"}
              required
              value={data.price.toString()}
              onChange={(e) => handleNumberChange("price", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="end" gap={1}>
            <Button
              type="button"
              variant="outlined"
              onClick={() => {
                handleOpen();
              }}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained"
              onClick={() => {
                onSubmit(data);
              }}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
}
